import React, { useEffect, useState, useRef } from 'react';
import { DocumentsServices } from '../../../services';
import { useDocumentPreview } from '../../../utils/useDocumentPreview';
import './style.css';
import { Layout, Table, Space, Button, Modal, Input } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
const { Content } = Layout;

function News() {
  const fileElement = useRef(null);
  const { open: openPreview, modal: previewModal } = useDocumentPreview();

  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [submitError, setSubmitError] = useState(false);

  const [news, setNews] = useState([]);
  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [showUpdateNewModal, setShowUpdateNewModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [newId, setNewId] = useState(null);

  async function fetchNews() {
    try {
      const response = await DocumentsServices.fetchDocuments('news');
      setNews(response.data);
    } catch(error) {
      console.log(error);
    }
  }

  function handleShowUpdateNewModal(notice) {
    setNewId(notice.id);
    setTitle(notice.title);
    setSubtitle(notice.subtitle);
    setShowUpdateNewModal(true);
  }

  async function handleDeleteNew(notice) {
    setIsLoading(true);
    try {
      await DocumentsServices.deleteDocument(notice.id);
      await fetchNews();
    } catch(error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  const columns = [
    {
      title: 'Título',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Subtítulo',
      dataIndex: 'subtitle',
      key: 'subtitle',
    },
    {
      title: 'Arquivo',
      dataIndex: 'file',
      key: 'file',
      render: (_, record) => (
        <Button
          onClick={() => openPreview(record.filename, record.title)}
        >
          Ver
        </Button>
      )
    },
    {
      title: 'Data de Criação',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: text => text.split('T')[0].split('-').reverse().join('/'),
    },
    {
      title: 'Ações',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => handleShowUpdateNewModal(record)}
          >
            <EditOutlined />
          </Button>
          <Button
            onClick={() => handleDeleteNew(record)}
          >
            <DeleteOutlined />
          </Button>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    async function fetchNews() {
      try {
        const response = await DocumentsServices.fetchDocuments('news');
        setNews(response.data);
      } catch(error) {
        console.log(error);
      }
    }

    fetchNews();
  }, []);

  function handleCloseAddNewModal() {
    setTitle('');
    setSubtitle('');
    setSelectedFile(null);
    setSubmitError(false);
    if (fileElement.current) {
      fileElement.current.value = '';
    }
    setShowAddNewModal(false);
  }

  function handleCloseUpdateNewModal() {
    setTitle('');
    setSubtitle('');
    setSelectedFile(null);
    setShowUpdateNewModal(false);
  }

  async function handleAddNew() {
    if(title.length < 3 || fileElement.current.files.length < 1) {
      return setSubmitError('Os campos devem ser preenchidos corretamente.');
    }
    setSubmitError(false);
    setIsLoading(true);

    const formData = new FormData();
    formData.append('title', title);
    formData.append('subtitle', subtitle);
    formData.append('category', 'news');
    formData.append('file', fileElement.current.files[0]);
    try {
      await DocumentsServices.addDocument(formData);
      await fetchNews();
      handleCloseAddNewModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  async function handleUpdateNew() {
    const payload = {};
    if(title.length > 2) {
      payload.title = title;
    }
    if(subtitle.length > 0) {
      payload.subtitle = subtitle;
    }
    setSubmitError(false);
    setIsLoading(true);
    try {
      await DocumentsServices.updateDocument(newId, payload);
      await fetchNews();
      handleCloseUpdateNewModal();
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  return (
    <Content style={{ margin: '24px 16px 0' }}>
      {previewModal}
      <Modal
        visible={showAddNewModal}
        destroyOnClose
        title="Adicionar Notícia"
        onOk={handleAddNew}
        onCancel={handleCloseAddNewModal}
        footer={[
          <Button key="back" onClick={handleCloseAddNewModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleAddNew}>
            Cadastrar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Título"
          size="large"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Input
          className="login-input"
          placeholder="Subtítulo"
          size="large"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
        <input style={{ marginTop: '20px' }} type="file" ref={fileElement} />
      </Modal>
      <Modal
        visible={showUpdateNewModal}
        destroyOnClose
        title="Atualizar Notícia"
        onOk={handleUpdateNew}
        onCancel={handleCloseUpdateNewModal}
        footer={[
          <Button key="back" onClick={handleCloseUpdateNewModal}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={handleUpdateNew}>
            Atualizar
          </Button>,
        ]}
      >
        <Input
          className="login-input"
          placeholder="Usuário"
          size="large"
          defaultValue={title || ''}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <Input
          className="login-input"
          placeholder="Senha"
          size="large"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
        />
      </Modal>
      <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          Notícias
          <Button className="button-add-news" type="primary" onClick={() => {
            setTitle('');
            setSubtitle('');
            setSubmitError(false);
            if (fileElement.current) fileElement.current.value = '';
            setShowAddNewModal(true);
          }}>
            Adicionar notícia
          </Button>
        </div>
        {news.length > 0 && (
          <Table rowKey="id" style={{ marginTop: '40px' }} columns={columns} dataSource={news} />
        )}
      </div>
    </Content>
  );
}

export default News;